import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import {
  Alert,
  Container,
  Button,
  Row,
  Col,
  Form,
  FormControl
} from 'react-bootstrap';
import { config } from '../../config';
import { Toast } from '../student/Home';
import Header from '../header/Header';
import { Wrapper } from '../../styles/HomeStyles';
import { FormWrapper, Label } from '../../styles/LoginStyles';

class ResetPasswordConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new_password: '',
      passwordError: '',
      status: '',
      alertSuccess: false,
      alertFailure: false
    };
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSaveClick = () => {
    this.setState({ passwordError: '' });
    this.setState({ status: '' });

    const { token } = this.props.match.params;
    const data = {
      pass1: this.state.new_password,
      pass2: this.state.confirm_new_password
    };

    console.log(data, 'data');
    axios
      .post(`${config.API_URL}user/auth/user/reset-password/${token}`, data)
      .then(response => {
        this.setState({
          status: 'You have successfully changed your password',
          alertSuccess: true
        });
      })
      .catch(error => {
        // if (
        //   error.response &&
        //   error.response.data.hasOwnProperty('new_password')
        // ) {
        //   this.setState({ passwordError: error.response.data.new_password });
        // } else {
        //   this.setState({ status: 'error' });
        // }
      });
  };

  handleClose = (event, reasons) => {
    if (reasons === 'clickaway') {
      return;
    }
    this.setState({
      alertFailure: false,
      alertSuccess: false
    });
  };

  render() {
    const errorAlert = (
      <Alert variant="danger">
        <Alert.Heading>Problem during new password set </Alert.Heading>
        <p>
          Please try <Link to="/send_reset_password">reset password</Link> again
          or contact service support for further help.
        </p>
      </Alert>
    );

    const successAlert = (
      <Alert variant="success">
        <Alert.Heading>New Password Set</Alert.Heading>
        <p>
          You can <Link to="/login/">Login</Link> to your account with new
          password.
        </p>
      </Alert>
    );

    const form = (
      <div>
        <FormWrapper>
          <Form>
            <Form.Group controlId="emailId">
              <Form.Label>Your New Password</Form.Label>
              <Form.Control
                isInvalid={this.state.passwordError}
                type="password"
                name="new_password"
                placeholder="Enter new password"
                value={this.state.new_password}
                onChange={this.onChange}
              />
              <FormControl.Feedback type="invalid">
                {this.state.passwordError}
              </FormControl.Feedback>
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                isInvalid={this.state.passwordError}
                type="password"
                name="confirm_new_password"
                placeholder="Confirm new password"
                value={this.state.confirm_new_password}
                onChange={this.onChange}
              />
              <FormControl.Feedback type="invalid">
                {this.state.passwordError}
              </FormControl.Feedback>
            </Form.Group>
          </Form>
          <Button
            color="primary"
            disabled={
              this.state.new_password === '' ||
              this.state.confirm_new_password === ''
            }
            onClick={this.onSaveClick}
          >
            Save
          </Button>
        </FormWrapper>
      </div>
    );

    let alert = '';
    if (this.state.status === 'error') {
      alert = errorAlert;
    } else if (this.state.status === 'success') {
      alert = successAlert;
    }

    return (
      <Container>
        <Header isHome={true} center={true} />
        <Wrapper>
          <Snackbar
            open={this.state.alertFailure}
            autoHideDuration={3000}
            onClose={this.handleClose}
          >
            <Toast onClose={this.handleClose} severity="error">
              {this.state.status}
            </Toast>
          </Snackbar>
          <Snackbar
            open={this.state.alertSuccess}
            autoHideDuration={3000}
            onClose={this.handleClose}
          >
            <Toast onClose={this.handleClose} severity="success">
              {this.state.status}
            </Toast>
          </Snackbar>
          <center>
            <h1>Set a New Password</h1>
            {alert}
            {!this.state.alertSuccess && form}
            {this.state.alertSuccess && (
              <Label>
                <Link to="/login">Proceed to Login</Link>
              </Label>
            )}
          </center>
        </Wrapper>
      </Container>
    );
  }
}

ResetPasswordConfirm.propTypes = {};

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(withRouter(ResetPasswordConfirm));
